// extracted by mini-css-extract-plugin
export default {"alert":"ResultsDisplay_alert__albhx","card":"ResultsDisplay_card__Q8Wz9"};